export const SET_PRICE_BARS_RESULT = 'priceBars/SET_PRICE_BARS_RESULT';
export const UPDATE_PRICE_BARS_RESULT = 'priceBars/UPDATE_PRICE_BARS_RESULT';
export const UPDATE_PRICE_BARS_VISIBILITY = 'priceBars/UPDATE_PRICE_BARS_VISIBILITY';
export const SET_DISPLAY_PRICE_BARS = 'priceBars/SET_DISPLAY_PRICE_BARS';

export const SET_FETCHING_PRICE_BARS = 'priceBars/SET_FETCHING_PRICE_BARS';
